import { render, staticRenderFns } from "./pin.vue?vue&type=template&id=1264104d&scoped=true&"
import script from "./pin.vue?vue&type=script&lang=js&"
export * from "./pin.vue?vue&type=script&lang=js&"
import style0 from "./pin.vue?vue&type=style&index=0&id=1264104d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1264104d",
  null
  
)

export default component.exports